import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Globals } from 'src/app/globals';
// import { UserService } from '../../service/user.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';

declare var $: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  emailForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      // Validators.minLength(4),
      // Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.maxLength(50)
    ]),
  });
  showLoader: boolean = true;
  searching: boolean = false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  // data = [
  //   {
  //     id: 1,
  //     username: "user1",
  //     type: "student",
  //     email: "user1@domain.com",
  //     displayName: "user1",
  //     mobile: "xxxxxxxxxxx",
  //     active: true,
  //     organization: "organization1",
  //     role: "role1"
  //   },
  //   {
  //     id: 2,
  //     username: "user2",
  //     type: "teacher",
  //     email: "user2@domain.com",
  //     displayName: "user1",
  //     mobile: "xxxxxxxxxxx",
  //     active: true,
  //     organization: "organization2",
  //     role: "role2"
  //   }
  // ];




  users: any = [];
  usersSearch: any;
  dataTablesParameters: any;
  totalRecords = 10;
  pageLength = 4;
  currentIndex = 0;
  paging: any = [];

  constructor(private toastrService: ToastrService, public globals: Globals, private http: HttpClient, private router: Router
    // , private userService: UserService
    , public translate: TranslateService
    , private userService: UserService
  ) {
    this.createPaging();
  }

  ngOnInit(): void {

    //   this.getDatatableData(this.currentIndex, this.pageLength, true);
    this.showLoader = false;

  }



  getUserByName() {
    // if (this.emailForm.valid) {
    // this.usersSearch = this.data[0];
    // this.updateTable();
    let email = this.emailForm.value.email;
    if (email === '') {
      email = 'all';
    }

    this.searching = true;
    this.userService.searchByUsername(email)
      .subscribe(
        data => {
          if (data) {
            this.usersSearch = data;
            this.updateTable();
            this.searching = false;

          } else {
            this.toastrService.warning(this.translate.instant("NOT_FOUND"));
            this.updateTable();
            this.searching = false;
          }
        },
        error => {
          this.toastrService.warning(this.translate.instant("CAN_NOT_GET_USER"));
          this.updateTable();
          this.searching = false;
        },
        () => this.searching = false
      );
    // }
    // else {
    //   this.toastrService.warning(this.translate.instant("PLEASE_ENTER_VALID_VALUE"));
    // }
  }

  createPaging() {
    let pagCount = this.totalRecords / this.pageLength;
    for (let i = 0; i < pagCount; i++) {
      this.paging.push(i);
    }

  }


  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [8] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
        // buttons: [
        //   'excel', 'pdf'
        // ]
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV'
        },
        {
          extend: 'pdfHtml5',
          text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
          titleAttr: 'PDF'
        }]
      });
    }, 1);
  }


  userDetails(userID: any) {
    console.log(userID);
    this.router.navigate(
      ['/user/user-details'],
      { queryParams: { userID: userID } });
  }

  userDelete(userID: any) {
    this.userService.deleteUserById(userID)
      .subscribe(
        data => {
          this.toastrService.success(this.translate.instant('DELETED_SUCCESSFULLY'));
          window.location.reload();
        },
        error => {
          this.toastrService.warning(this.translate.instant('CAN_NOT_DELETE'));

        }
      );
  }

  editUser(username: string) {
    this.router.navigate(
      ['user/update-user'],
      { queryParams: { userName: username } });
  }



}
